import React from 'react'
import { useInfiniteQuery } from 'react-query'

import { useStickerAction } from '@hooks/sticker/useStickerAction'
import { GetStickerListResponse } from '@models/sticker/GetStickerListResponse'
import {
  TiptapStickerButtonProps,
  WithTiptapStickerButtonProps,
} from './interface'

const PER_PAGE = 20

export function withTiptapStickerButton(
  Component: React.FC<TiptapStickerButtonProps>
) {
  function WithTiptapStickerButton(props: WithTiptapStickerButtonProps) {
    const stickerClient = useStickerAction()

    const { fetchNextPage, data, isFetchingNextPage } = useInfiniteQuery(
      'sticker-list',
      async ({ pageParam = 1 }) => {
        const res = await stickerClient.getStickerList({
          page: pageParam,
          perpage: PER_PAGE,
        })

        return res
      },
      {
        staleTime: Infinity,
        getNextPageParam: (lastPage: GetStickerListResponse) => {
          if (lastPage.data.length) return lastPage.page + 1

          return undefined
        },
      }
    )

    function handleFetchNextPage() {
      if (!isFetchingNextPage) fetchNextPage()
    }

    const componentProps = {
      ...props,
      stickerList: data,
      handleFetchNextPage,
    }

    return <Component {...componentProps} />
  }

  return WithTiptapStickerButton
}
